export type ReportRange = 'Today' | '7 days' | '30 days';

export const REPORT_RANGES: ReportRange[] = ['Today', '7 days', '30 days'];

export function rangeDays(range: ReportRange): number {
  switch (range) {
    case 'Today':
      return 1;
    case '7 days':
      return 7;
    case '30 days':
      return 30;
  }
}

/** Inclusive window ending now, as ISO bounds for the API. */
export function rangeBounds(range: ReportRange): { start: string; end: string } {
  const end = new Date();
  const start = new Date(end);
  start.setHours(0, 0, 0, 0);
  if (range !== 'Today') {
    start.setDate(start.getDate() - (rangeDays(range) - 1));
  }
  return { start: start.toISOString(), end: end.toISOString() };
}

export function rangeFileSlug(range: ReportRange): string {
  return range.replace(' ', '-').toLowerCase();
}
